import Immutable from 'immutable';
export const keyIn = (...keys) => {
  const keySet = Immutable.Set(keys);
  return (val, key) => keySet.has(key);
};